import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
function normalizeArgs(arg1, arg2) {
  if (typeof arg1 === "undefined") return { title: null, message: null };
  if (typeof arg1 === "string")
    return { title: arg1 ?? null, message: arg2 ?? null };
  if (arg1 && typeof arg1 === "object") {
    const { title = null, message = null } = arg1;
    return { title, message };
  }
  return { title: null, message: null };
}
const AppLoadingContext = createContext({
  isLoading: false,
  title: "",
  message: "",
  showLoading: ({ title = null, message = null } = {}) => {},
  hideLoading: () => {},
  withLoading: async (fn, _t, _m) => {},
});

export function AppLoadingProvider({ children }) {
  const [s, setS] = useState({ isLoading: false, title: "", message: "" });

  const showLoading = useCallback((arg1, arg2) => {
    const { title, message } = normalizeArgs(arg1, arg2);
    setS({ isLoading: true, title, message });
  }, []);
  const hideLoading = useCallback(
    () => setS({ isLoading: false, title: "", message: "" }),
    []
  );

  const withLoading = useCallback(
    async (fn, { title, message } = {}) => {
      try {
        showLoading({ title, message });
        return await fn();
      } finally {
        hideLoading();
      }
    },
    [showLoading, hideLoading]
  );

  const value = useMemo(
    () => ({ ...s, showLoading, hideLoading, withLoading }),
    [s, showLoading, hideLoading, withLoading]
  );
  return (
    <AppLoadingContext.Provider value={value}>
      {children}
    </AppLoadingContext.Provider>
  );
}

export function useAppLoading() {
  return useContext(AppLoadingContext);
}
